export const SET_IS_MULTI_SELECT = "SELECT_MEDIA_SET_IS_MULTI_SELECT";
export const SET_TARGET_ROUTE = "SELECT_MEDIA_SET_TARGET_ROUTE";
export const SET_TARGET_COMPONENT = "SELECT_MEDIA_SET_TARGET_COMPONENT";
export const SELECT_MEDIA = "SELECT_MEDIA_SELECT_MEDIA";
export const RESET_SELECT_MEDIA = "SELECT_MEDIA_RESET";
